export const OFFLINE_REGISTRATION_PATH = '/offline-registration'

export const canAccessOfflineRegistration = (user) =>
  Boolean(
    user?.uid &&
      Array.isArray(user.providerData) &&
      user.providerData.some((provider) => provider?.providerId === 'password')
  )
